import { useTranslation } from "react-i18next";
import singleMode from "./filterBaseSingle";

const rawItems = [
	{
		key: "woman",
		value: 0,
		meta: {
			url: "0",
			value: "woman",
		},
	},
	{
		key: "man",
		value: 1,
		meta: {
			url: "1",
			value: "man",
		},
	},
	{
		key: "couple",
		value: 2,
		meta: {
			url: "2",
			value: "couple",
		},
	},
	{
		key: "transsexual",
		value: 3,
		meta: {
			url: "3",
			value: "transsexual",
		},
	},
];

export { rawItems };

export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.meta.url);
	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.meta.value : null;
	},
	valueToUrl: (value) => {
		const current = rawItems.find((item) => item.value === Number(value));
		return current ? current.meta.url : "";
	},
	urlToApiParam: (value) => {
		if (!value) return null;
		const current = rawItems.find((item) => item.meta.url === value);
		return current ? current.meta.value : null;
	},
	urlToValue: (value) => {
		if (!value) return null;
		return value.map(
			(string) =>
				rawItems.find(({ meta: { url } }) => url === string)?.value ?? 0
		);
	},
};

const useFilterSearchSex = ({ initial }) => {
	const { t } = useTranslation(["common"]);

	const items = rawItems.map((item) => ({
		...item,
		content: t(`common:sexOptions.${item.key}`),
		text: t(`common:sexOptions.${item.key}`),
	}));

	return {
		items,
		compute,
		isValid,
		...singleMode({ items, initial, compute }),
	};
};

export default useFilterSearchSex;
